module.exports = __webpack_public_path__ + "static/assets/97c8a7617ba8e8147c0bb952b151d5b7.png";